import { render, staticRenderFns } from "./Add_promotion_mobile.vue?vue&type=template&id=9b801072&"
import script from "./Add_promotion_mobile.vue?vue&type=script&lang=js&"
export * from "./Add_promotion_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Add_promotion_mobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports